import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserProfileService } from './api/user-profile.service';
@Injectable({
  providedIn: 'root'
})
export class RoleGuard {
  constructor(
    private router: Router,
    private userProfileService: UserProfileService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.userProfileService.isBusinessUserRole()) {
      if (state.url.includes('/customer')
        || state.url.includes('/help')
        || state.url.includes('/user/settings')) {
        return true;
      }
      return this.router.createUrlTree(['/customer']);
    }
    return true;
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.canActivate(route, state);
  }

}
